let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1qeuS")).then(() => parcelRequire('f7aUi'));